import React, { useEffect, useContext } from 'react'
import styled from 'styled-components'
import { Color, Colors } from '../styles/Colors';
import { AgendaContext } from '../context/AgendaContext';
import ToggleSection from './ToggleSection';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
    border-bottom: 2px solid ${Color(Colors.black)};

    & > h2 {
        padding: 2rem 0 2rem 0; 
    }

    & > div {
        & > input {
            background-color: ${Color(Colors.white)}; 
        }
    }
`;

const Remote = () => {
    const { t } = useTranslation(); 
    const { meetingLink, setMeetingLink, meetingId, setMeetingId, meetingPassCode, setMeetingPassCode } = useContext(AgendaContext);

    useEffect(() => {
        localStorage.setItem('meeting_link', meetingLink);
        localStorage.setItem('meeting_id', meetingId);
        localStorage.setItem('meeting_passcode', meetingPassCode);
    }, [meetingLink, meetingId, meetingPassCode])

    return (
        <Wrapper>
            <h2>{t('remoteParticipation.title')}</h2>
            <div>
                <ToggleSection title={t('remoteParticipation.formLabels.link.name')}>
                    <input
                        name='link'
                        type='text'
                        value={meetingLink || ''}
                        onChange={(event) => setMeetingLink(event.target.value || '')}
                        placeholder={t('remoteParticipation.formLabels.link.label')}
                        spellCheck={false}
                    />
                </ToggleSection>
                <ToggleSection title={t('remoteParticipation.formLabels.meetingId.name')}>
                    <input
                        name='id'
                        type='text'
                        value={meetingId || ''}
                        onChange={(event) => setMeetingId(event.target.value || '')}
                        placeholder={t('remoteParticipation.formLabels.meetingId.label')}
                        spellCheck={false}
                    />
                </ToggleSection>
                <ToggleSection title={t('remoteParticipation.formLabels.passcode.name')}>
                    <input
                        name='passCode'
                        type='text'
                        value={meetingPassCode || ''}
                        onChange={(event) => setMeetingPassCode(event.target.value || '')}
                        placeholder={t('remoteParticipation.formLabels.passcode.label')}
                        spellCheck={false}
                    />
                </ToggleSection>
            </div>
        </Wrapper>
    )
}

export default Remote